//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapMutations} from "vuex";

export default {
  name: "FieldEditDialog",
  data: () => ({
    show: false,
    field: null,
    type: null,
    language: null,
    allProperties: [],
    languages: {
      en: {
        id: "en",
        value: "English"
      },
      other: {
        id: "other",
        value: "Other"
      }
    }
  }),

  computed: {
    ...mapGetters(["showFieldEdit", "editFieldData"]),

    currentTerms: function () {
      return this.editFieldData.terms
        ? eval(this.editFieldData.terms)
        : [];
    }
  },

  watch: {
    showFieldEdit: function () {
      this.show = this.showFieldEdit;
    },

    show: function (newVal) {
      if (!newVal) {
        this.setShowFieldEdit(newVal);
      }
    },

    editFieldData: function (newVal) {
      console.log("field data", newVal);
      this.type = this.editFieldData.type;
      this.field = this.editFieldData.field;
      this.language = newVal.language || this.languages.en;
    }
  },

  methods: {
    ...mapMutations({
      setShowFieldEdit: "setShowFieldEdit"
    }),

    doneEditing() {
      this.allProperties.forEach(prop => {
        if (prop.field === this.field) {
          prop.type = this.type;
          if (this.type === "txt") {
            prop.language = this.language;
          }
        }
      });
      this.show = false;
    },

    cancelEditing() {
      this.show = false;
    }
  }
};
